import videojs from 'video.js';

class Analitics extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);
        player.on('ready', () => {
            options.init(this.player);
            this.setListeners(options);
        });
    }

    setListeners(options) {
        const { events } = options;
        if (events) {
            Object.keys(events).forEach((eventName) => {
                events[eventName].forEach((eventData) => {
                    let elements = this.player.el().querySelectorAll(eventData.selector);
                    for (let el of elements) {
                        el.addEventListener(eventName, eventData.handler);
                    }
                });
            });
        }
    }
}

videojs.registerPlugin('analitics', Analitics);
